// components/TokenExpiryHandler.jsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { clearPermissions } from '../store/slices/permissionsSlice';

const TokenExpiryHandler = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const expiryTime = decoded.exp * 1000;
        const timeUntilExpiry = expiryTime - Date.now();

        if (timeUntilExpiry <= 0) {
          dispatch(clearPermissions());
          localStorage.removeItem('token');
          navigate('/login');
        } else {
          const timeout = setTimeout(() => {
            dispatch(clearPermissions());
            localStorage.removeItem('token');
            navigate('/login');
          }, timeUntilExpiry);

          return () => clearTimeout(timeout); // Cleanup
        }
      } catch (error) {
        console.error("Invalid token:", error);
        dispatch(clearPermissions());
        localStorage.removeItem('token');
        navigate('/login');
      }
    }
  }, [navigate]);

  return null;
};

export default TokenExpiryHandler;
